import React from 'react';

import { Box, Text } from '@components/Restyle';

type Props = {
  /** The number displayed inside the badge */
  count: string;

  /** Badge background color */
  backgroundColor?: string;

  /** Badge border color */
  borderColor?: string;

  /** Text color inside the badge */
  textColor?: string;

  /** Minimum width of the badge */
  minWidth?: number;

  /** Fixed height of the badge */
  height?: number;
};

export const CountBadgeWeb: React.FC<Props> = ({
  count,
  backgroundColor = 'grey01',
  borderColor = 'grey02',
  textColor = 'textPrimary',
  minWidth = 20,
  height = 20,
}) => {
  return (
    <Box
      marginLeft='xxs'
      backgroundColor={backgroundColor as any}
      borderColor={borderColor as any}
      height={height}
      minWidth={minWidth}
      borderWidth={1}
      alignItems='center'
      justifyContent='center'
      // Border radius is half of height to make it pill-shaped
      style={{ borderRadius: height / 2 }}>
      <Text
        variant='webBodyHintSubline'
        color={textColor as any}
        mx={count.length > 2 ? 'xxxs' : 'none'}>
        {count}
      </Text>
    </Box>
  );
};
